module.exports = __webpack_public_path__ + "media/images/lb/656-fd0419e0de4da9b05659886b78f292bb.svg";